export class IdName {
    id: any;
    name: any;

    constructor(id: any, name: any) {
        this.id = id;
        this.name = name;
    }
}
